import React from 'react';
import { Carousel, Row, Col, Card, Button } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import styled from 'styled-components';

const StyledCarousel = styled(Carousel)`
  .slick-prev, .slick-next {
    z-index: 10;
  }
`;

const carouselItems = [
  {
    id: 1,
    title: 'Tập tạ',
    description: 'Xây dựng sức mạnh và cơ bắp',
    image: 'https://i.pinimg.com/736x/5a/f4/96/5af496e575105b81072cdaaa6fe6ba28.jpg'
  },
  {
    id: 2,
    title: 'Chạy bộ',
    description: 'Cải thiện tim mạch và sức bền',
    image: 'https://classpass-res.cloudinary.com/image/upload/f_auto/q_auto/azhqlcjegdbhee9reg3v.jpg'
  },
  {
    id: 3,
    title: 'Tập nhóm',
    description: 'Tập luyện cùng mọi người',
    image: 'https://www.danang43.vn/wp-content/uploads/2024/05/strong-body-fitness-1.jpg'
  }
];

const FitnessCarousel = ({ items = carouselItems, onItemClick }) => {
  return (
    <div style={{ position: 'relative' }}>
      <StyledCarousel
        arrows
        prevArrow={<Button icon={<LeftOutlined />} shape="circle" />}
        nextArrow={<Button icon={<RightOutlined />} shape="circle" />}
      >
        <div>
          <Row gutter={[24, 24]}>
            {items.map(item => (
              <Col key={item.id} xs={24} md={8}>
                <Card
                  cover={<img alt={item.title} src={item.image} />}
                  hoverable
                >
                  <Card.Meta 
                    title={item.title} 
                    description={item.description} 
                  />
                  {/* <Button 
                    type="primary" 
                    style={{ marginTop: 16 }}
                    onClick={() => onItemClick && onItemClick(item)}
                  >
                    Tìm hiểu thêm
                  </Button> */}
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      </StyledCarousel>
    </div>
  );
};

export default FitnessCarousel;